// eslint-disable-next-line no-extra-semi
(function (widgets) {
  var numScripts = 0;
  var allResponsesId = null;
  var Protect = widgets.Widget.extend(
    {
      constructor: function CaptchaConstructor(object) {
        mainNav.nextButton.bind(
          'click keypress',
          $.proxy(all_loaded, window, object)
        );
        Protect.__super__.constructor.call(this, object);

        numScripts = Object.keys(object.integrations).length;
        allResponsesId = '#r-' + object.input_id;
      },
      render: function render(object) {
        Protect.__super__.render.call(this, object);

        var self = this;

        $.each(Object.keys(this._object.integrations), function (i, name) {
          var integration = self._object.integrations[name];
          self._injectScript(name, integration);
        });
      },

      _injectScript: function (name, data) {
        var snippet = document.createElement('script');
        snippet.type = 'text/javascript';
        snippet.id = 'protect-' + name;
        switch (name) {
          case 'rd':
            snippet.innerHTML = `
              $.ajax({
                type: "POST", 
                url: "https://prod.rtymgt.com/api/v4/respondents/search/${data.api_key}",
                withCredentials: true,
                data:  JSON.stringify({
                  sy_nr: "${data.survey_id}",
                  rt_sr_pd: "${data.encoded_person_id}",
                  sn_ud: "${data.visa}"
                }),
                dataType: 'json',
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .done(function(data) {
                $("#integration-rd-response").val(JSON.stringify(data));
              })
              .fail(function() {                
                $("#integration-rd-response").val(JSON.stringify('SCRIPT_LOADING_ERROR'));
              })
              .always(function() {
                var current_loaded = parseInt($('#loaded-scripts').val());
                $('#loaded-scripts').val(current_loaded+1);
                
                if (NODE_ENV === 'development') {
                  console.log('Protect Widget: Snippet for Research Defender loaded');
                }
              });
            `;
            break;
          case 'vs':
            var interval;

            snippet.setAttribute('verisoul-project-id', data.project_id);
            snippet.setAttribute('data-id', data.userAccountId);
            snippet.src = `https://js.${data.environment}.verisoul.xyz/bundle.js`;
            snippet.onload = () => {
              var userAccount = $('#protect-vs').data('id');
              interval = setInterval(function () {
                if (typeof Verisoul !== 'undefined') {
                  Verisoul.onAuth(userAccount);
                  $('#integration-vs-response').val(JSON.stringify({}));
                  clearInterval(interval);
                }
              }, 50);

              var current_loaded = parseInt($('#loaded-scripts').val());
              $('#loaded-scripts').val(current_loaded + 1);

              if (NODE_ENV === 'development') {
                console.log('Protect Widget: Snippet for Verisoul loaded');
              }
            };
            break;
        }
        document
          .getElementsByClassName('protect-widget')[0]
          .appendChild(snippet);
      },

      destroy: function destroy() {
        var tags = document.querySelectorAll('script[id*="protect-"]');
        tags.forEach(function (tag) {
          $(tag).remove();
        });
      },
    },
    {
      types: ['protect'],
      views: ['protect'],
    }
  );

  var all_loaded = function () {
    var loadedScripts = parseInt($('#loaded-scripts').val());

    var allResponses = {};
    var responseInputs = document.querySelectorAll('input[id*="integration-"]');
    responseInputs.forEach(function (tag) {
      try {
        allResponses[tag.name] = JSON.parse(tag.value);
      } catch (e) {
        // GRYP-9802: Handle exception when
        // `tag.value` is not parseable JSON
        allResponses[tag.name] = 'SCRIPT_LOADING_ERROR';
      }
    });

    if (loadedScripts === numScripts) {
      $(allResponsesId).val(JSON.stringify(allResponses));
      click_next({ key: '', type: 'click' });
    }
  };

  Protect.register();
  widgets.Protect = Protect;
})((Gryphon.widgets = Gryphon.widgets || {}));
